/** Current origin in the browser; the production origin while pre-rendering at build time. */
export function siteOrigin(): string {
  return typeof window === "undefined" ? "https://archiinvites.com" : window.location.origin;
}
